export default function getProductImage(id: number, size: string): string {
  //const image_base_url = process.env.REACT_APP_BASE_URL;
  return `/images/shop/${size}/${id}.png`;
  //return `/images/shop/product${key}.png`;
}
